var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.736 4.44939H3.31177L4.96654 2.79463C5.26741 2.49376 5.26741 2.04246 4.96654 1.7416C4.66567 1.44073 4.21437 1.44073 3.91351 1.7416L0.98006 4.59983C0.904844 4.67504 0.829627 4.75026 0.754411 4.90069C0.679194 5.05113 0.679194 5.27678 0.754411 5.42721C0.829627 5.50243 0.829627 5.57764 0.904844 5.65286L3.83829 8.58631C3.98872 8.73674 4.21437 8.81196 4.36481 8.81196C4.51524 8.81196 4.74089 8.73674 4.89132 8.58631C5.19219 8.28544 5.19219 7.83414 4.89132 7.53327L3.31177 5.95373H11.736C13.9925 5.95373 15.7977 7.98457 15.7977 10.4667C15.7977 12.9489 13.9925 14.9797 11.736 14.9797H3.01091C2.55961 14.9797 2.25874 15.2806 2.25874 15.7319C2.25874 16.1832 2.55961 16.4841 3.01091 16.4841H11.736C14.8199 16.4841 17.3021 13.7763 17.3021 10.4667C17.3021 7.15719 14.8199 4.44939 11.736 4.44939Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.c7865a3fce4730e6c17794ae66cabe7e.svg";
export { ForwardRef as ReactComponent };